import React, { createContext, useContext, useEffect, useState } from 'react';
import {
  DesktopMessage,
  DesktopMessageAuthSessionResponse,
  useDesktop
} from '@revenuewell/logic-desktop';
import { Claims, DesktopWidgetOidcService, useOidc } from '@revenuewell/logic-oidc';

export const DesktopOidcContext = createContext(null);

// todo: rename to desktop widget
export function DesktopOidcProvider(props: React.PropsWithChildren<unknown>) {
  let authConnectionInterval: any = null;
  const { getClaims, getAccessToken, oidcService, isAuthenticated, logoutRedirect } = useOidc();
  const { isDesktopApplication, listenMessage, sendMessage, isDesktopWidget } = useDesktop(); // todo: clear cache
  const [ready, setReady] = useState<boolean>(!(isDesktopApplication() && isDesktopWidget));

  useEffect(() => {
    if (isDesktopApplication()) {
      const unsubscribe1 = listenMessage('desktop-auth-session-request', () => shareAuthSession());
      const unsubscribe2 = listenMessage('desktop-auth-session-response', (e: DesktopMessage) => {
          const { accessToken, claims } = (e as DesktopMessageAuthSessionResponse).payload;
          setAuthSession(accessToken, claims as Claims)
        }
      );
      const unsubscribe3 = listenMessage('desktop-sign-out', () => logoutRedirect());

      return () => {
        unsubscribe1();
        unsubscribe2();
        unsubscribe3();
      };
    }
  }, []);

  useEffect(() => {
    if (isDesktopApplication() && isDesktopWidget) {
      keepAuthConnection();
      return () => clearInterval(authConnectionInterval);
    }
  }, []);

  const shareAuthSession = async () => {
    sendMessage({
      type: 'desktop-auth-session-response',
      payload: {
        accessToken: (await getAccessToken())!,
        claims: await getClaims()
      }
    });
  };

  const setAuthSession = (accessToken: string, claims: Claims) => {
    if (isDesktopWidget) {
      const desktopWidgetOdicService = oidcService as DesktopWidgetOidcService;
      desktopWidgetOdicService.setAccessToken(accessToken);
      desktopWidgetOdicService.setClaims(claims);
    }
  };

  const keepAuthConnection = () => {
    authConnectionInterval = setInterval(() => {
      if (!isAuthenticated()) sendMessage({type: 'desktop-auth-session-request'});
      setReady(isAuthenticated());
    }, 2000);
  };

  return <DesktopOidcContext.Provider value={null!}>{ready && props.children}</DesktopOidcContext.Provider>;
}

export function useDesktopOidc() {
  const context = useContext(DesktopOidcContext);

  if (!context) {
    throw new Error('useDesktopOidc must be used within the DesktopOidcProvider');
  }

  return context;
}
